module.exports = __webpack_public_path__ + "static/media/1-10.d93c3a25.mp3";